import { useSelector } from 'react-redux';

/** Simple selector to get featureToggleMap */
const featureTogglesSelector = state =>
  state?.featureToggles?.featureToggleMap ?? {};

/**
 * Return the value of a given feature flag in the store
 * @param {string} featureToggle The feature to check for
 * @returns {'true'|'false'} Whether or not feature has been enabled. This value is string not boolean
 */
export const useFeatureFlag = featureToggle => {
  const featuresEnabled = useSelector(featureTogglesSelector);
  return featuresEnabled?.[featureToggle] ?? 'false';
};

/**
 * Check whether a given feature *toggle* is enabled
 * @param {string} featureToggle The feature to check for
 * @returns {boolean} Whether or not feature has been enabled
 */
export const useFeatureToggle = featureToggle => {
  const featureEnabled = useFeatureFlag(featureToggle);
  // _Toggle_ values are actually strings that look like booleans:
  // For example: "true" / "false"
  return featureEnabled === 'true';
};

export default useFeatureToggle;
